import { $menuOpen, $lastFocusedElement, toggleMenu as storeToggleMenu } from '../_store.js';
import * as focusTrap from 'focus-trap';
import debounce from 'debounce';
class ReadingProgress extends HTMLElement {
  constructor() {
    super();
    // Binding methods
    this.bndUpdateProgress = this.updateProgress.bind(this);
    this.bndHandleResize = debounce(this.calculateDimensions.bind(this), 250);

    // Initialize properties
    this.docHeight = 0;
    this.pageHeight = 0;
    this.windowHeight = 0;
  }
  connectedCallback() {
    // Calculate dimensions initially
    this.calculateDimensions();

    // Add event listeners
    window.addEventListener('scroll', this.bndUpdateProgress, {
      passive: true
    });
    window.addEventListener('resize', this.bndHandleResize);

    // Update progress initially
    this.updateProgress();
  }
  disconnectedCallback() {
    // Clean up event listeners
    window.removeEventListener('scroll', this.bndUpdateProgress);
    window.removeEventListener('resize', this.bndHandleResize);
  }
  calculateDimensions() {
    // Get document height (total scrollable height)
    this.docHeight = document.documentElement.scrollHeight;

    // Get viewport height
    this.windowHeight = window.innerHeight;

    // Calculate actual scrollable distance (total height minus viewport height)
    this.pageHeight = this.docHeight - this.windowHeight;

    // Update progress after recalculating dimensions
    this.updateProgress();
  }
  updateProgress() {
    // Get current scroll position
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Calculate progress percentage
    let progress = scrollTop / this.pageHeight * 100;

    // Clamp value between 0-100
    progress = Math.min(100, Math.max(0, progress));

    // Round to 5 decimal places
    progress = parseFloat(progress.toFixed(5));

    // Set CSS variable for styling
    this.style.setProperty('--reading-progress', progress);
  }
}
customElements.define('reading-progress', ReadingProgress);